// 9fbef606107a605d69c0edbcd8029e5d
import filter from 'lodash/filter';
import { isCanada, parseBoolean } from '@tcp/core/src/utils';
import { renderLabel } from '@tcp/core/src/utils/labels/labelUtilty';
import {
  getSearchBarLabels,
  lblSearchLookingFor,
  lblPopularSearch,
} from '@tcp/core/src/components/common/molecules/SearchBar/labels/searchBar.labels';
import processHelpers from '../../productListing/processHelpers';
import { initiateApiCall } from '../../../handler';
import endpoints from '../../../endpoints';
/**
 * @function errorHandler function to handle all the server side errors.
 * @param {object} err - error object in case server side data send server side validation errors.
 * @returns {object} error object with appropirate error message
 */
const errorHandler = (err) => {
  if (err && err.errorResponse && err.errorResponse.errorMessage) {
    throw new Error(err.errorResponse.errorMessage);
  }
  throw new Error('genericError');
};

/**
 * @function sortAutoSuggest
 * @summary This will sort the list of object on the basis of list of properties provided to the function.
 * @param {Object[]} array - This is a list of items on which sort need to executed
 * @param {Array} sortOrderList - This is a list of order property. Sorting while happen in the
 * same order in which items are there in the list, result will contain the items
 * on the top which matches first list item from this list then after the second list item and so on.
 * @param {String} sortKey - This is a property name which is use to sort the list
 * @return {Object} This is a list with sorted items
 */
// eslint-disable-next-line class-methods-use-this
const sortAutoSuggest = (array, sortOrderList, sortKey) => {
  array.sort((a, b) => {
    const A = a[sortKey];
    const B = b[sortKey];
    if (
      sortOrderList.indexOf(A) > sortOrderList.indexOf(B) ||
      sortOrderList.indexOf(A) === sortOrderList.indexOf(B)
    ) {
      return 1;
    }
    return -1;
  });
  return array;
};

/**
 * @function removeDuplicateAutosuggest
 * @summary This will removes the duplicate items from the provided list.
 * @param {Object[]} autosuggestItems - This is a list of items from which duplicate item to be removed
 * @param {String} propertyName - This is a property name on which duplicate items to be removed
 * @return {Object} This is a list with unique items
 */
// eslint-disable-next-line class-methods-use-this
const removeDuplicateAutosuggest = (autosuggestItems, propertyName) => {
  const uniqueItems = autosuggestItems.reduce((acc, cur) => {
    acc[cur[propertyName].toLowerCase()] = cur;
    return acc;
  }, {});

  // logic to sort in order of response
  const toBeSortedUniqueItems = Object.values(uniqueItems);
  const sortedUniqueItems = [];
  autosuggestItems?.forEach((item, index) => {
    if (toBeSortedUniqueItems[index]?.text === item?.text) {
      sortedUniqueItems.push(toBeSortedUniqueItems[index]);
    } else {
      toBeSortedUniqueItems?.forEach((sortingItem) => {
        if (sortingItem?.text === autosuggestItems[index]?.text) {
          sortedUniqueItems[index] = sortingItem;
        }
      });
    }
  });
  return sortedUniqueItems;
};

const getProductList = (response, productAttributes) => {
  return response.products
    .filter((item) => 'catgroup_id' in item)
    .map((product) => {
      const bundleProduct = product.product_type === 'BUNDLE' || false;
      const pdpURLID = product.seo_token || product.uniqueId;
      return {
        name: product.product_name,
        imageUrl: product.imageUrl,
        listPrice:
          parseFloat(product.TCPCustomListPrice) || parseFloat(product.min_list_price) || 0,
        offerPrice:
          parseFloat(product.TCPCustomSalePrice) || parseFloat(product.min_offer_price) || 0,
        lowListPrice: parseFloat(product.low_list_price) || 0,
        lowOfferPrice: parseFloat(product.low_offer_price) || 0,
        highListPrice: parseFloat(product.high_list_price) || 0,
        highOfferPrice: parseFloat(product.high_offer_price) || 0,
        isBundleProduct: bundleProduct,
        productUrl: `${bundleProduct ? '/b' : '/p'}/${pdpURLID}`,
        keepAlive: parseBoolean(product[productAttributes.keepAlive]),
        rating: product.TCPBazaarVoiceRating,
        reviewCount: product.TCPBazaarVoiceReviewCount,
        TCPMerchantTagUSStore: product.TCPMerchantTagUSStore,
        TCPMerchantTagCanadaStore: product.TCPMerchantTagCanadaStore,
        primaryBrand: !isCanada()
          ? product.TCPPrimaryBrandUSStore
          : product.TCPPrimaryBrandCanadaStore,
        prodId: product?.uniqueId,
      };
    });
};
const checkIfBundleProduct = (product) => {
  return (product.product_type && product.product_type.toLowerCase() === 'bundle') || false;
};
const getProductListWebEnhancement = (response, productAttributes) => {
  return response.products
    .filter((item) => 'catgroup_id' in item)
    .map((product) => {
      const bundleProduct = checkIfBundleProduct(product);
      const pdpURLID = product.seo_token || product.uniqueId;
      return {
        name: product.product_name,
        imageUrl: product.imageUrl,
        listPrice:
          parseFloat(product.TCPCustomListPrice) || parseFloat(product.min_list_price) || 0,
        offerPrice:
          parseFloat(product.TCPCustomSalePrice) || parseFloat(product.min_offer_price) || 0,
        lowListPrice: parseFloat(product.low_list_price) || 0,
        lowOfferPrice: parseFloat(product.low_offer_price) || 0,
        highListPrice: parseFloat(product.high_list_price) || 0,
        highOfferPrice: parseFloat(product.high_offer_price) || 0,
        isBundleProduct: bundleProduct,
        productUrl: `${bundleProduct ? '/b' : '/p'}/${pdpURLID}`,
        keepAlive: parseBoolean(product[productAttributes.keepAlive]),
        primaryBrand: !isCanada()
          ? product.TCPPrimaryBrandUSStore
          : product.TCPPrimaryBrandCanadaStore,
        rating: product.TCPBazaarVoiceRating,
        reviewCount: product.TCPBazaarVoiceReviewCount,
        TCPMerchantTagUSStore: product.TCPMerchantTagUSStore,
        TCPMerchantTagCanadaStore: product.TCPMerchantTagCanadaStore,
        prodId: product?.uniqueId,
      };
    });
};

const filterTrendingSearches = (filterProperties, products) => {
  let isTopSearchPresent = false;
  let isKeywordPresent = false;
  // eslint-disable-next-line
  products?.map((item) => {
    if (item?.doctype === 'TOP_SEARCH_QUERIES') {
      isTopSearchPresent = true;
    } else if (item?.doctype === 'KEYWORD_SUGGESTION') {
      isKeywordPresent = true;
    }
  });
  if (isTopSearchPresent && isKeywordPresent) {
    // eslint-disable-next-line no-unused-expressions
    filterProperties?.splice(1, 1);
    return filterProperties;
  }
  return filterProperties;
};

/**
 * @function makeSearchApi - Used as abstract layer to do all server request and recieve the track order info.
 * @param {object} payload - data required to make server request.
 * @returns {object} success response or error response.
 */

export const makeSearch = (
  input,
  xappURLConfig,
  isWebSearchEnabled = false,
  defaultResultCount = 4
) => {
  const globalSearchBarLabels = getSearchBarLabels();
  const {
    suggestionsCount,
    searchTerm,
    isHideBundleProduct,
    isSearchEnhancementCall,
    isSLPPersistEnabled,
  } = input;
  const searchLookingForLabelText = renderLabel(
    globalSearchBarLabels[lblSearchLookingFor],
    lblSearchLookingFor
  );
  const bundleFilter = isHideBundleProduct ? { filter: '-product_type:BUNDLE' } : {};
  let inputProductCount = defaultResultCount;
  if (isSearchEnhancementCall) {
    inputProductCount = 0;
  }
  if (isWebSearchEnabled || isSearchEnhancementCall) {
    inputProductCount = 6;
  } else if (input?.productsCounts) {
    inputProductCount = input.productsCounts;
  }
  if (isSLPPersistEnabled) {
    inputProductCount = 0;
  }
  const payload = {
    header: {},
    body: {
      ...bundleFilter,
      variants: true,
      q: isSearchEnhancementCall ? '*' : searchTerm,
      version: 'V2',
      sourceFields: 'categoryLinkMap',
      'sourceField.categoryLinkMap.count': suggestionsCount.category,
      'keywordSuggestions.count': isSearchEnhancementCall ? 12 : suggestionsCount.keywords,
      'topQueries.count': isSearchEnhancementCall ? 12 : suggestionsCount.promotedTopQueries,
      'popularProducts.count': inputProductCount,
      'popularProducts.fields':
        'catgroup_id,product_name,imageUrl,min_list_price,min_offer_price,TCPOutOfStockFlagUSStore,TCPOutOfStockFlagCanadaStore,seo_token,uniqueId,product_type,low_offer_price, high_offer_price, low_list_price, high_list_price,TCPPrimaryBrandUSStore,TCPPrimaryBrandCanadaStore,TCPBazaarVoiceRating,TCPBazaarVoiceReviewCount,TCPMerchantTagUSStore,TCPMerchantTagCanadaStore,TCPCustomSalePrice,TCPCustomListPrice',
    },
    webService: endpoints.searchBarApi,
  };
  return initiateApiCall(payload, null, xappURLConfig)
    .then((res) => {
      const { response } = res.body;
      if (!response) {
        throw new Error('Response has errors!');
      }
      const productAttributes = processHelpers.getProductAttributes();
      // Iterate through the full response and grab only the data we require
      // filter out product list from the API response

      const productsList = isWebSearchEnabled
        ? getProductListWebEnhancement(response, productAttributes)
        : getProductList(response, productAttributes);
      // filter out search suggestion from API response on the basis of filter properties
      let filterProperties = ['PROMOTED_SUGGESTION', 'KEYWORD_SUGGESTION', 'TOP_SEARCH_QUERIES']; // There are properties that need to be filterd out
      filterProperties = isSearchEnhancementCall
        ? filterTrendingSearches(filterProperties, response?.products)
        : filterProperties;
      const terms = filter(response.products, (item) =>
        filterProperties.includes(item.doctype)
      ).map((val) => {
        return { text: val.autosuggest, docType: val.doctype };
      });

      // sort the filtered result so that the 'PROMOTED_SUGGESTION' would be on the top of the result
      const sortedAutoSuggestItems = sortAutoSuggest(terms, filterProperties, 'docType');

      // Revoving duplicate item from the search suggestion.
      const autoSuggestItems = removeDuplicateAutosuggest(sortedAutoSuggestItems, 'text');
      return {
        autosuggestList: [
          {
            heading: searchLookingForLabelText,
            suggestions: autoSuggestItems,
            searchTerm,
          },
        ],
        autosuggestProducts: productsList,
      };
    })
    .catch(errorHandler);
};

export const makePopularSearch = (input, xappURLConfig) => {
  const globalSearchBarLabels = getSearchBarLabels();
  const { searchTerm } = input;
  const payload = {
    header: {},
    body: {
      variants: true,
      q: '*',
      version: 'V2',
      'keywordSuggestions.count': 0,
      'topQueries.count': 10,
      'popularProducts.count': 0,
      'inFields.count': 0,
    },
    webService: endpoints.searchBarApi,
  };
  const popularSearchLabelText = renderLabel(
    globalSearchBarLabels[lblPopularSearch],
    lblPopularSearch
  );

  return initiateApiCall(payload, null, xappURLConfig)
    .then((res) => {
      const { response } = res.body;

      if (!response) {
        throw new Error('Response has errors!');
      }
      const productAttributes = processHelpers.getProductAttributes();
      // Iterate through the full response and grab only the data we require
      // filter out product list from the API response
      const productsList = getProductList(response, productAttributes);

      // filter out search suggestion from API response on the basis of filter properties
      const filterProperties = ['TOP_SEARCH_QUERIES']; // There are properties that need to be filterd out
      const terms = filter(response.products, (item) =>
        filterProperties.includes(item.doctype)
      ).map((val) => {
        return { text: val.autosuggest, docType: val.doctype };
      });

      // sort the filtered result so that the 'PROMOTED_SUGGESTION' would be on the top of the result
      const sortedAutoSuggestItems = sortAutoSuggest(terms, filterProperties, 'docType');

      // Revoving duplicate item from the search suggestion.
      const autoSuggestItems = removeDuplicateAutosuggest(sortedAutoSuggestItems, 'text');

      return {
        autosuggestList: [
          {
            heading: popularSearchLabelText,
            suggestions: autoSuggestItems,
            searchTerm,
          },
        ],
        autosuggestProducts: productsList,
      };
    })
    .catch(errorHandler);
};
